// extracted by mini-css-extract-plugin
export default {"card":"M0atckt_eTPf_0heTtoo","body":"BdNZXhiiHWoUxvJGfpCT","footer":"HFd8CLF2LpE14mc12LUu","header":"blY9LvKAbNdsD9Y_zB_l"};